"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLatest = void 0;
/**
 * Convert the Metadata (which is an alias) to latest
 * @internal
 **/
function toLatest(_registry, v15, _metaVersion) {
    return v15;
}
exports.toLatest = toLatest;
